<template>
  <div class="hello">
    <div class="case">
      <!-- 头部 -->
      <div class="top">
        <div class="ti-blck"></div>
        <div class="title">DWC 2022 Attendance Survey</div>
        <p
          class="introduce"
        >Thank you for your time to participate in this survey which we will be very much appreciated for helping us to provide a better conference experience.</p>
        <p class="must">*必填</p>
      </div>
      <!-- 尾部 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <div class="tail">
          <div class="cause">
            Please tell us why you are not sure to participate in Drone World Congress this year?
            <span
              class="sign"
            >*</span>
          </div>

          <el-form-item prop="type">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="The mandatory quarantines (imposedby China 14 days)" name="type"></el-checkbox>
              <br />
              <el-checkbox
                label="The mandatory quarantines (imposed by my home country)"
                name="type"
              ></el-checkbox>
              <br />
              <el-checkbox label="Current boarder-crossing policy is not friendly" name="type"></el-checkbox>
              <br />
              <el-checkbox
                label="I am not interested in the topics of the DWC 2020 this year"
                name="type"
              ></el-checkbox>
              <br />
              <el-checkbox label="There are limited flights with abnormally high price" name="type"></el-checkbox>
              <br />
              <el-checkbox label="I don't feel safe to travel this year" name="type"></el-checkbox>
              <br />
              <el-checkbox label="其他:" name="type"></el-checkbox>
              <br />
              <el-input class="elseinp" v-model="ruleForm.other" placeholder="请填写 “其他” 原因描述"></el-input>
            </el-checkbox-group>
            
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="subbin" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ruleForm: {
        type: [],
        other: ""
      },
      chebox: "",
      rules: {
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeCreate() {
     
  },
  created(){
    //记录访问数量
     this.$axios({
      url:
        "http://en.droneworldcongress.com/form/index/nosure/index.html?button_id=" +
         this.$route.query.button_id +
        "&contacts_id=" +
        this.$route.query.contacts_id,
      method: "post",
      data: {
        
      }
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let button_id = this.$route.query.button_id;
          let contacts_id = this.$route.query.contacts_id;

        
          let permission = this.ruleForm.type.join(",");
          let url = "http://en.droneworldcongress.com/form/index/nosure/index.html?button_id=" +localStorage.getItem('button_id') +"&contacts_id=" + localStorage.getItem('contacts_id')
          this.$axios({
            url:
              "http://en.droneworldcongress.com/form/index/nosure/index.html?button_id=" +
              button_id +
              "&contacts_id=" +
              contacts_id,
            method: "post",
            data: {
              checkbox: permission,
              other: this.ruleForm.other,
              url: url
            }
          })
            .then(res => {
              this.$router.push({name:'succeed'});
            })
            .catch(err => {
               this.$message({
                message: '提交失败',
                type: 'warning'
              });
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.case {
  margin: auto;
  max-width: 90vw;
  width: 640px;
  padding-top: 12px;
}
.hello {
  width: 100%;
  height: 100%;
  /* position: fixed; */
  background-color: rgb(240, 235, 248);
  background-size: 100% 100%;
}
.top {
  /* margin-top: 12px; */
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  padding-top: 22px;
  position: relative;
  text-align: left;
}
.ti-blck {
  background-color: rgb(103, 58, 183);
  color: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: calc(100% + 2px);
}
.title {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  color: #202124;
  line-height: 135%;
  max-width: 100%;
  min-width: 0%;
}
.introduce {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  color: #202124;
  margin-top: 12px;
}
.must {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  margin-top: 12px;
  color: #d93025;
}
.el-checkbox{
    white-space: pre-line !important;
}
.el-checkbox__label{
    display: initial !important;
}

/* 尾部 */
.tail {
  -webkit-transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  page-break-inside: avoid;
  word-wrap: break-word;
  text-align: left;
}
.cause {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  color: #202124;
  font-weight: 400;
  width: 100%;
  word-break: break-word;
}
.form-inp {
  margin-left: 0px !important;
}
.sign {
  color: #d93025;
}
/* .elseinp {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #42b983;
} */
.subbin{
  background-color: rgb(103, 58, 183);
  margin-bottom: 30%;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/NotSure.vue